var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveeMainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.7954 8.18456C10.0555 8.18456 11.8877 6.35238 11.8877 4.09228C11.8877 1.83218 10.0555 0 7.7954 0C5.5353 0 3.70312 1.83218 3.70312 4.09228C3.70312 6.35238 5.5353 8.18456 7.7954 8.18456Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85476 15.2622C8.05262 14.403 7.6071 13.271 7.60848 12.0955C7.60848 10.8433 8.10476 9.70564 8.91131 8.86933C8.54673 8.84105 8.17396 8.82617 7.79449 8.82617C5.32276 8.82617 3.1345 9.44448 1.77586 10.3708C0.739402 11.0777 0.167971 11.9757 0.167971 12.9185V13.9973C0.167677 14.1635 0.200193 14.3281 0.263656 14.4817C0.327118 14.6353 0.420278 14.7749 0.537792 14.8924C0.655306 15.0099 0.794863 15.1031 0.948458 15.1665C1.10205 15.23 1.26667 15.2625 1.43286 15.2622H8.85476Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2617 8.1875C10.1055 8.1875 8.35547 9.93751 8.35547 12.0938C8.35547 14.25 10.1055 16 12.2617 16C14.418 16 16.168 14.25 16.168 12.0938C16.168 9.93751 14.418 8.1875 12.2617 8.1875ZM10.4641 12.7441L11.5802 13.4881C11.6875 13.5596 11.8163 13.5917 11.9446 13.5789C12.0729 13.5662 12.1929 13.5094 12.2841 13.4182L14.1442 11.5581C14.2488 11.4535 14.3075 11.3116 14.3075 11.1637C14.3075 11.0158 14.2488 10.8739 14.1442 10.7694C14.0396 10.6648 13.8977 10.606 13.7498 10.606C13.6019 10.606 13.4601 10.6648 13.3555 10.7694L11.8183 12.3058L11.0832 11.8155C10.96 11.7353 10.8102 11.707 10.6663 11.7366C10.5224 11.7662 10.3959 11.8514 10.3144 11.9736C10.2329 12.0959 10.2029 12.2454 10.2309 12.3896C10.259 12.5339 10.3428 12.6612 10.4641 12.7441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveeMainIcon);
export default __webpack_public_path__ + "static/media/activee-main-icon.5e239f85e07e32954d9ea10a755a52f0.svg";
export { ForwardRef as ReactComponent };